import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getAboutSectionInitActions(responseData) {
  return [
    getSectionLayoutInitAction(responseData, 'about'),
    ...getAllModulesInitActions(responseData),
  ].filter(action => action);
}
